// extracted by mini-css-extract-plugin
export default {"switch":"DateEnableSwitch_switch__UdknX"};